'use client';

import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import HtmlContentWrapper from '@/components/HtmlContentWrapper';

interface FAQItem {
  title: string;
  description: string;
}

interface SectionFAQProps {
  faq?: FAQItem[];
  className?: string;
}

export default function SectionFAQ({ faq, className = '' }: SectionFAQProps) {
  // Если нет FAQ или массив пустой, не показываем компонент
  if (!faq || faq.length === 0) {
    return null;
  }

  return (
    <section className={`mt-8 ${className}`}>
      <h2 className="text-2xl md:text-3xl font-semibold mb-6 text-gray-900">
        Часто задаваемые вопросы
      </h2>
      <Accordion type="single" collapsible className="w-full">
        {faq.map((item, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger className="text-left text-base md:text-lg font-medium text-gray-900 hover:no-underline">
              {item.title}
            </AccordionTrigger>
            <AccordionContent>
              <div className="text-sm md:text-base text-gray-700 leading-relaxed">
                <HtmlContentWrapper html={item.description} />
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}

